import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTheme } from '../context/ThemeContext';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* Ensure it's above other content */
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid ${({ theme }) => (theme.mode === 'dark' ? '#383838' : '#F0F7FF')};
  border-top: 5px solid ${({ theme }) => (theme.mode === 'dark' ? '#F0F7FF' : '#0052B4')};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-left: ${({ $notLeftMargin }) => ($notLeftMargin ? '0px' : '300px')};

  @media (max-width: 768px) {
    margin-left: 0; /* Remove margin for mobile view */
  }
`;

const LoaderModal = (props) => {
    const leftMargin = props.notLeftMargin ?? false;
    const { theme } = useTheme();

    return (
        <ModalOverlay>
            <Spinner theme={theme} $notLeftMargin={leftMargin} />
        </ModalOverlay>
    );
};

export default LoaderModal;
